module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['global-auth-box d-flex justify-center align-center', {
      hide: !_vm.show
    }],
    on: {
      "click": function($event) {
        _vm.show = false
      }
    }
  }, [_c('div', {
    staticClass: "g-auth-box",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('div', {
    staticClass: "back-box"
  }, [_c('span', {
    on: {
      "click": _vm.showGlobalLogin
    }
  }, [_c('i', {
    staticClass: "fas fa-chevron-left fa-fw"
  }), _vm._v("\n        Login\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "select-txt"
  }, [_vm._v("Select an account type")]), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-space-between"
  }, [_c('div', {
    staticClass: "box-type",
    on: {
      "click": _vm.showSignup
    }
  }, [_c('i', {
    staticClass: "fas fa-user fa-3x fa-fw"
  }), _vm._v(" "), _c('div', [_vm._v("Regular Account")])]), _vm._v(" "), _c('div', {
    staticClass: "box-type",
    on: {
      "click": _vm.showCorporate
    }
  }, [_c('i', {
    staticClass: "fas fa-user-tie fa-3x fa-fw"
  }), _vm._v(" "), _c('div', [_vm._v("Corporate Account")])])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-75a2f17c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75a2f17c","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Global/GlobalSignupSelect.vue
// module id = 2114
// module chunks = 0